export default "__VITE_ASSET__CzxLjCsA__"